import * as v2 from './v2';
import { V2 } from '../constants/machine-state/machine';

export default {
  [V2]: v2
}
